import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function MuiDialogPasswordReset(props) {

  return (
    <div>
      <Dialog
        open={props.showModal}
        onClose={props.handleClose}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          Confirm Password Reset
        </DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText
            id="scroll-dialog-description"
            // ref={descriptionElementRef}
            tabIndex={-1}
          >
            <div>
              You are about to reset the password for the selected room(s).
              This action cannot be undone, would you like to proceed?
            </div>
            <div style={{ height: "10px" }}></div>
            {
              props.roomList.map((thisRoom) => {
                return <div>{thisRoom}</div>
              })
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleConfirm}>Confirm</Button>
          <Button onClick={props.handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
